module.exports = __webpack_public_path__ + "assets/TPerpBisector.46b2209185ca3510706f926e95e00ecd.gmt";


//////////////////
// WEBPACK FOOTER
// ./src/resources/levels/Gmt/TPerpBisector.gmt
// module id = 1015
// module chunks = 0